/* =========================================================================
   AYNA · Nails — Entry point.
   No Three.js, no WebGL. Pure editorial layout + GSAP.
   ========================================================================= */
import "./styles/typography.css";
import "./styles/base.css";
import {
	initPageIndicator,
	initCoverParallax,
	initServicesInteraction,
	initGalleryInteraction,
} from "./motion/index.ts";

function boot(): void {
	initPageIndicator();
	initCoverParallax();
	initServicesInteraction();
	initGalleryInteraction();

	const form = document.querySelector<HTMLFormElement>(".booking-form");
	if (form) {
		form.addEventListener("submit", (ev) => {
			ev.preventDefault();
			const submit = form.querySelector<HTMLButtonElement>(".booking-submit");
			if (submit) {
				const original = submit.textContent;
				submit.textContent = "Спасибо — отвечу в течение часа";
				submit.disabled = true;
				setTimeout(() => {
					submit.textContent = original;
					submit.disabled = false;
					form.reset();
				}, 3200);
			}
		});
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
